import React, { useEffect } from 'react';
import { X, Truck, Heart, MapPin } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import AuthForm from '../AuthForm/AuthForm';
import './AuthModal.css';

const TEXT = {
  checkout: ['Log in for faster checkout', 'Use your saved details and addresses.'],
  login: ['Log in', '']
};

// Log-in popup — opens only when the shopper taps a "Log in" button
const AuthModal = () => {
  const { authModal, closeAuth, finishAuth } = useAuth();

  useEffect(() => {
    if (!authModal) return undefined;
    const onKey = e => e.key === 'Escape' && closeAuth();
    document.addEventListener('keydown', onKey);
    const overflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = overflow;
    };
  }, [authModal, closeAuth]);

  if (!authModal) return null;
  const [title, subtitle] = TEXT[authModal.reason] || TEXT.login;

  return (
    <div className="auth-modal-backdrop" onMouseDown={e => e.target === e.currentTarget && closeAuth()}>
      <div className="auth-modal" role="dialog" aria-modal="true" aria-label={title}>
        <button type="button" className="auth-modal-close" onClick={closeAuth} aria-label="Close">
          <X size={20} />
        </button>
        <AuthForm title={title} subtitle={subtitle} onSuccess={finishAuth} />
        <ul className="auth-modal-perks">
          <li><Truck size={15} /> Track all your orders</li>
          <li><MapPin size={15} /> Saved addresses</li>
          <li><Heart size={15} /> Faster checkout</li>
        </ul>
      </div>
    </div>
  );
};

export default AuthModal;
